import { render } from "./Bank.vue?vue&type=template&id=6e25f1a9&scoped=true&ts=true"
import script from "./Bank.vue?vue&type=script&lang=ts"
export * from "./Bank.vue?vue&type=script&lang=ts"

import "./Bank.vue?vue&type=style&index=0&id=6e25f1a9&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e25f1a9"]])

export default __exports__